// extracted by mini-css-extract-plugin
export var actions = "_if-d";
export var benefitCard = "_if-a";
export var benefitIcon = "_if-b";
export var benefitLabel = "_if-c";
export var benefits = "_if-9";
export var bodyText = "_if-8";
export var closeButton = "_if-2";
export var content = "_if-3";
export var eyebrow = "_if-4";
export var heading = "_if-5";
export var image = "_if-f";
export var imagePanel = "_if-e";
export var modal = "_if-0";
export var shell = "_if-1";
export var title = "_if-6";
export var titleOffer = "_if-7";